import { types } from './types';
import { axiosPut, axiosGet } from '../../main/app-axios';

export const getEntregador = async ({ codigoExterno }) => dispatch => {

  return axiosGet(`/api/pedidos/${codigoExterno}/entregador/packk`, {}, dispatch)   
    .then(response => {
      if (response && response.status === 200) {
        dispatch({
          type: types.GET_ENTREGADOR,
          payload: {
            entregador: response.data,
            loaded: true,
            error: false,
            errorData: null
          },
        });
      } else if (response && response.status === 404) {
        dispatch({
          type: types.GET_ENTREGADOR,
          payload: {
            entregador: {},
            loaded: true,
            error: true,
            errorData: response.data
          },
        });
      } else {
        dispatch({
          type: types.GET_ENTREGADOR,
          payload: {
            entregador: {},
            loaded: true,
            error: true,
            errorData: null
          },
        });
      }
    });
};

export const getEntregadorEuEntrego = async ({ codigoExterno }) => dispatch => {

  return axiosGet(`/api/pedidos/${codigoExterno}/entregadorEuEntrego`, {}, dispatch)   
    .then(response => {
      if (response && response.status === 200) {
        dispatch({
          type: types.GET_ENTREGADOR,
          payload: {
            entregador: response.data,
            loaded: true,
            error: false,
            errorData: null
          },
        });
      } else if (response && response.status === 404) {
        dispatch({
          type: types.GET_ENTREGADOR,
          payload: {
            entregador: {},
            loaded: true,
            error: true,
            errorData: response.data
          },
        });
      } else {
        dispatch({
          type: types.GET_ENTREGADOR,
          payload: {
            entregador: {},
            loaded: true,
            error: true,
            errorData: null
          },
        });
      }
    });
};
